import ConversationComponent from 'components/messaging/conversation';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import styled, { css } from 'styled-components';

const Container = styled.div<{ mobileMode?: boolean }>`
  ${({ mobileMode }) =>
    mobileMode &&
    css`
      padding: 0 20px;
    `}
`;

const ConversationPage: FC<{ mobileMode?: boolean }> = ({ mobileMode }) => {
  const { id } = useParams();

  return (
    <Container mobileMode={mobileMode}>
      <ConversationComponent
        url={`/messaging/conversation/${id}`}
        backTo="/mentor/mentorship/messaging"
      />
    </Container>
  );
};

export default ConversationPage;
